function parseLineHeight(lineHeight) {
  if (lineHeight === "paragraph") {
    return "1.5";
  }
  return `${lineHeight}`;
}

export { parseLineHeight };
//# sourceMappingURL=parseLineHeight.mjs.map
